/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ShopifyStoreLocationsRequest
 */
export interface ShopifyStoreLocationsRequest {
  /**
   *
   * @type {string}
   * @memberof ShopifyStoreLocationsRequest
   */
  integrationId: string;
}

/**
 * Check if a given object implements the ShopifyStoreLocationsRequest interface.
 */
export function instanceOfShopifyStoreLocationsRequest(
  value: object,
): value is ShopifyStoreLocationsRequest {
  if (!("integrationId" in value) || value["integrationId"] === undefined)
    return false;
  return true;
}

export function ShopifyStoreLocationsRequestFromJSON(
  json: any,
): ShopifyStoreLocationsRequest {
  return ShopifyStoreLocationsRequestFromJSONTyped(json, false);
}

export function ShopifyStoreLocationsRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShopifyStoreLocationsRequest {
  if (json == null) {
    return json;
  }
  return {
    integrationId: json["integrationId"],
  };
}

export function ShopifyStoreLocationsRequestToJSON(
  json: any,
): ShopifyStoreLocationsRequest {
  return ShopifyStoreLocationsRequestToJSONTyped(json, false);
}

export function ShopifyStoreLocationsRequestToJSONTyped(
  value?: ShopifyStoreLocationsRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    integrationId: value["integrationId"],
  };
}
